<template>
  <div class="popover-wizard">
    <div
      :style="popover_style"
      class="app-popover-wizard-widget"
      :class="{ show: show_wizard, child: selected_item_type == 'child' }"
      :id="`popover_${selected_index}`"
    >
      <div class="app-popover-wizard-widget-header">
        <button @click="closePopover()" class="btn-close">&times;</button>
      </div>
      <div class="app-popover-wizard-widget-body">
        <div class="app-popover-title" v-if="selected_item">
          {{ selected_item.title }}
        </div>
        <div v-if="selected_item" class="app-popover-content">
          {{ selected_item.content }}
        </div>
      </div>
      <div class="app-popover-wizard-widget-footer">
        <button
          v-if="active_wizard_item < wizard_items.length - 1"
          class="btn-next"
          @click="nextWizardItem()"
        >
          Next
        </button>
        <button
          v-if="active_wizard_item < wizard_items.length - 1"
          class="btn-skip"
          @click="closePopover()"
        >
          Skip
        </button>
        <button v-else class="btn-next" @click="closePopover()">Close</button>
      </div>
      <div
        class="arrow-left"
        v-if="selected_item"
        :class="selected_item.arrow"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "appPopoverWizard",
  components: {},
  props: {},
  data: () => {
    return {
      popover_style: {
        top: "0px",
        left: "0px",
      },
      wizard_items: [
        {
          title: "Search",
          content:
            "This is a smart search that will provide results from elements in the CRM.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-0",
          page: "/search",
          children: [
            {
              title: "Search",
              content: "Type any keyword in  this search field",
              next: "Next",
              close: "Close",
              position: "bottom-center",
              arrow: "bottom-center",
              id: "#main-search-input",
              page: null,
            },
            {
              title: "Search",
              content: "Use the available filters to simplify the search.",
              next: "Next",
              close: "Close",
              position: "bottom-center",
              arrow: "bottom-center",
              id: "#main-search-filter",
              page: null,
            },
            {
              title: "Search",
              content:
                "Lastly, use the search button to see the results below.",
              next: "Next",
              close: "Close",
              position: "bottom-center",
              arrow: "bottom-center",
              id: "#main-search-btn",
              page: null,
            },
          ],
        },
        {
          title: "Dashboard",
          content:
            "Dashbaord offers a list of all students, displaying their availability and utilisation, and allows status comments for each student.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-1",
          page: "/",
        },
        {
          title: "Tasks",
          content:
            "You can use tasks to classify and organise the activities at your school, as well as to allocate them to the appropriate instructors.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-2",
          page: "/task",
        },
        {
          title: "Instructor",
          content:
            "This is a process where the teacher keeps tabs on each student's LIA development from the start to the finish of the internship.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-3",
          page: "/instructor",
        },
        {
          title: "Accounts",
          content:
            "Accounts are your actual or prospective clients. You have access to the projects you are working on or have worked on. Additionally, you can locate customer contacts and other pertinent customer data.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-4",
          page: "/accounts",
        },
        {
          title: "School",
          content:
            "You control all of your school's data here, including the school's description, projects, student profiles, skills, etc.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-5",
          page: "/school/students",
        },
        {
          title: "LIA",
          content:
            "Search for potential LIA that suits your services, either internally or externally, and assign them to students.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-6",
          page: "/internship",
        },
        {
          title: "Resumes",
          content:
            "Apply CV templates to the student profiles, access all of your students' resumes in one place, and prepare professional sales pitches for your customers.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-7",
          page: "/cv/editor",
        },
        {
          title: "Candidates",
          content:
            "Through Candidates, you can manage the school recruitment process and get an overview.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-8",
          page: "/candidates",
        },
        {
          title: "Leads",
          content:
            "With leads, you can keep track of every potential client who might be interested in your services. You can designate the accountable instructor to receive them.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-9",
          page: "/leads",
        },
        {
          title: "Reports",
          content:
            "Reports allow you to keep tabs on your development, see trends or other anomalies that might require additional analysis in relation to the tasks, teacher, and skills.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-10",
          page: "/reports",
        },
        {
          title: "Communications",
          content:
            "The communications section will enable you in directly contacting students via email, chat, notifications, and surveys.",
          next: "Next",
          close: "Close",
          position: "left-center",
          arrow: "left-center",
          id: "#menu-item-11",
          page: "/communications",
        },
      ],
      show_wizard: false,
      active_wizard_item: null,
      active_child_wizard_item: -1,
      selected_item: null,
      selected_index: null,
      selected_item_type: "",
    };
  },

  mounted() {
    let vm = this;
    setTimeout(() => {
      vm.initiateWizard();
    }, 5000);
  },
  methods: {
    closePopover() {
      this.show_wizard = false;
    },
    initiateWizard() {
      let vm = this;
      vm.selected_item = vm.wizard_items[0];
      vm.$store
        .dispatch("USER_CHECK_WIZARD_STATUS")
        .then((responce) => {
          if (!responce.data.crm_wizard) {
            vm.showItemWizard(0, "parent");
            vm.show_wizard = true;
          }
        })
        .catch((error) => {});
    },
    nextWizardItem() {
      let vm = this;
      if (vm.active_wizard_item < vm.wizard_items.length - 1) {
        if (
          vm.wizard_items[vm.active_wizard_item].children &&
          vm.wizard_items[vm.active_wizard_item].children.length > 0 &&
          vm.active_child_wizard_item <
            vm.wizard_items[vm.active_wizard_item].children.length - 1
        ) {
          let nextItem = vm.active_child_wizard_item + 1;
          vm.selected_item =
            vm.wizard_items[vm.active_wizard_item].children[nextItem];
          vm.showItemWizard(nextItem, "child");
        } else {
          vm.active_child_wizard_item = -1;
          vm.selected_item = vm.wizard_items[vm.active_wizard_item + 1];
          vm.showItemWizard(vm.active_wizard_item + 1, "parent");
        }
      }
    },
    showItemWizard(index, type) {
      let vm = this;
      vm.selected_item_type = type;
      if (type == "parent") {
        vm.active_wizard_item = index;
      } else {
        vm.active_child_wizard_item = index;
      }
      let item_id = vm.selected_item.id;
      let page = vm.selected_item.page;
      let position = vm.selected_item.position;

      vm.selected_index = index;
      let menu = document.querySelector(item_id);

      // get menu position
      let menuPosition = menu.getBoundingClientRect();

      // get menu width
      let menuWidth = menu.offsetWidth;
      // get menu height
      let menuHeight = menu.offsetHeight;
      // get menu top
      let menuTop = menuPosition.top;
      // get menu left
      let menuLeft = menuPosition.left;
      // get menu right
      let menuRight = menuPosition.right;
      // get menu bottom
      let menuBottom = menuPosition.bottom;
      // get menu center
      let menuVCenter = menuTop + menuHeight / 2;
      let menuHCenter = menuTop + menuWidth / 2;

      if (page) {
        vm.$router.push({ path: page });
      }
      setTimeout(() => {
        let popover = document.querySelector(`#popover_${vm.selected_index}`);
        // Get popover position
        let popover_position = popover.getBoundingClientRect();
        let popoverHeight = popover_position.height;
        let popoverWidth = popover_position.width;
        // Set popover position
        if (position == "left-center") {
          vm.popover_style.top = menuVCenter - popoverHeight / 2 + "px";
          vm.popover_style.left = menuRight + "px";
        }
        if (position == "bottom-center") {
          vm.popover_style.top = menuBottom + 15 + "px";
          vm.popover_style.left = menuRight - menuHCenter + "px";
        }
      }, 100);
    },
  },
};
</script>
<style lang="scss" scoped>
.app-popover-wizard-widget {
  position: fixed;
  background: #0884af;
  border-radius: 8px;
  z-index: -22;
  display: flex;
  flex-direction: column;
  width: 300px;
  transition: all 100ms ease-in;
  &.show {
    z-index: 9999999999999;
    transition: all 0.5s ease-in-out;
  }
  .app-popover-wizard-widget-header {
    display: flex;
    justify-content: flex-end;
    height: 45px;
    align-items: center;
    padding: 0px 10px;
    .btn-close {
      font-size: 30px;
      color: #fff;
    }
  }
  .app-popover-wizard-widget-body {
    padding: 10px 20px;
    .app-popover-title {
      font-size: 20px;
      color: #fff;
      margin-bottom: 10px;
    }
    .app-popover-content {
      font-size: 14px;
      color: #fff;
    }
  }
  .app-popover-wizard-widget-footer {
    display: flex;
    justify-content: flex-end;
    height: 55px;
    align-items: center;
    padding: 0px 20px;
    .btn-next {
      background: #fff;
      color: #0884af;
      border: 1px solid #fff;
      border-radius: 5px;
      padding: 8px 10px;
      font-size: 14px;
      cursor: pointer;
    }
    .btn-skip {
      color: #fff;
      margin-left: 10px;
    }
  }
  .arrow-left {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid#0884af;
    position: absolute;
    &.left-center {
      top: 45%;
      left: -10px;
      transition: all 0.5s ease-in-out;
    }
    &.bottom-center {
      top: -15px;
      left: 50%;
      transform: rotate(90deg);
      transition: all 0.5s ease-in-out;
    }
  }
  &.child {
    background: #1ba5a4 !important;
    .btn-next {
      color: #1ba5a4 !important;
    }

    .arrow-left {
      border-right: 10px solid #1ba5a4 !important;
    }
  }
}
</style>
